// extracted by mini-css-extract-plugin
export default {"tooltip":"PieChartTooltip_tooltip__53kph","title":"PieChartTooltip_title__Ab+TO","content":"PieChartTooltip_content__z6vP6"};